import React from "react";
import s from "./style.module.css";
import cn from "classnames";
import Container from "../../Page/Container";

const Header = ({ copy }) => {
  const { title, one, two, three, standfirst } = copy;

  const ctaItems = [
    { text: one, icon: require(`./1.svg`).default },
    { text: two, icon: require(`./2.svg`).default },
    { text: three, icon: require(`./3.svg`).default },
  ];

  return (
    <div className={cn(s.wrap)}>
      <Container>
        <div className={s.header}>
          <h1 className={s.title}>{title}</h1>
          <div className={s.standfirst}>{standfirst}</div>

          <ul className={s.ctaItems}>
            {ctaItems.map(({ text, icon }) => (
              <li className={s.item} key={text}>
                <img
                  width="32"
                  height="32"
                  className={s.icon}
                  src={icon}
                  alt=""
                />
                <span className={s.text}>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </div>
  );
};

export default Header;
